import axios from "axios";

const requestInstance = (process) => {
	const csrfValue = window.xsrf_val;

	const headers = process.headers || {
		"X-Xsrf-Token": csrfValue,
		"X-XSRFToken": csrfValue,
	};

	return axios.create({
		headers,
	});
};

window.axios = axios;

export default requestInstance;
